import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { MembershipSelectAction } from "../hooks";
import { PlanBox } from "./PlanBox";
import { PlanFlourish } from "./PlanFlourish";

interface Props {
  action: MembershipSelectAction;
  trackers: {
    plusTracker: () => void;
    premiumTracker: () => void;
  };
}

export const PlanBoxes: FC<Props> = ({
  action,
  trackers: { plusTracker, premiumTracker },
}) => {
  return (
    <Flex
      align={{ base: "center", md: "stretch" }}
      direction={{ base: "column-reverse", md: "row" }}
      flexWrap={{ base: "nowrap", md: "wrap-reverse" }}
      gap={{ base: "2rem", md: "3rem" }}
      justify="center"
      w="full"
    >
      <PlanBox action={action} handleClick={plusTracker} type="plus" />
      <PlanBox
        action={action}
        flourish={<PlanFlourish />}
        handleClick={premiumTracker}
        type="premium"
      />
    </Flex>
  );
};
